
import React from 'react'

 

import KeeVue from '../base/KeeVue.js'


import $ from 'jquery';



export default class FsDrager extends KeeVue {
  constructor(props) {
         super(props);

			this.state =  {
				id: this.getRandString(),
				isShowDom: false,
				isFsBox:false,
				style: {
					left: "0px",
					top: "0px",
					width: "300px",
					height: "300px",
					'transform': '',
					'WebkitTransform': ''
				},
				fromBox: null,
				fromBoxId: null,
				currentSelectDom: null,
				currentSelectDomId: null,
				toBox: null,
				isMouseDown: false,
				startTimer: null,
				isDraging: false,
				point: {
					x: 0,
					y: 0
				},
				lastPoint: {
					x: 0,
					y: 0,
					boxid: null,
					targetId: null,
				},
				sourceRect: {
					left: 0,
					top: 0,
					width: 0,
					height: 0,
					offerX: 0,
					offerY: 0,
				},
				startPoint: {
					x: 0,
					y: 0,
				},
				endPoint: {
					x: 0,
					y: 0,
				},
				dragItem: null,
				hasChanged: false,
				isStartDrag: false,
				sendDraggingTimer: null,
				disableX: false,
				disableY: false,
				isStop: false,
				selectstart: false,
				countlog:0
			}

}

componentDidMount(){
			let that = this;
			this.registComponent();
			this.onEvent("drag.select", this.onDragSelect);
			this.onEvent("drag.updatePoint",function(point){
				that.state.startPoint.x = point.x;
				that.state.startPoint.y = point.y;
			});
			document.onselectstart = this.onselectstart;
			this.onEvent("drag.enableX", function() {
			 
				that.disableX = false;
				that.refresh();
			});
			this.onEvent("drag.disableX", function() {
				 
				that.disableX = true;
				that.refresh();
			});
			this.onEvent("drag.disableY", function() {
				that.state.disableY = true;
				that.refresh();
			});
			this.onEvent("drag.stop", function() {
				that.state.isStop = true;
				that.refresh();
			});
			this.onEvent("drag.start", function() {
				that.state.isStop = false;
				that.state.isDraging = true;
				that.refresh();
			});
			this.onEvent("drag.mousedown", function(isDown) {
				that.state.isMouseDown = isDown;
				that.refresh();
			});
			this.onEvent("drag.selectstart", function(data) {
				that.state.selectstart = data;
				that.refresh();
			});
			$("body").on("mouseup", function(event) {
				that.state.selectstart = true;
				that.refresh();
			});
		}

			onselectstart=()=> {
				return this.state.selectstart;
			}
			getTargetBox=(event)=> {
				let type = "boxid";
				let target = event.target;
				let fromBoxId = event.target.getAttribute(type);
				let fromBox = event.target;
				if(fromBoxId === null || fromBoxId === '') {
					let parent = event.target.parentNode;
					while(parent !== null && typeof parent.getAttribute === "function") {
						fromBoxId = parent.getAttribute(type);
						if(fromBoxId !== null && fromBoxId !== '') {
							target = parent;
							break;
						} else {
							parent = parent.parentNode;
						}
					}
				}
				return target;
			}
			getTargetComponentId=(event)=> {
				 
				let target = event.target;
				let boxid = event.target.getAttribute("boxid");
				if(boxid !== null && boxid !== '') {
					return null;
				}
				let tid = event.target.getAttribute("tid");
				let fromBox = event.target;
				if(!tid) {
					let parent = event.target.parentNode;
					while(parent  && typeof parent.getAttribute === "function") {
						boxid = parent.getAttribute("boxid");
						if(boxid ) {
							//console.log("找到boxid："+boxid);
							return null;
						}
						tid = parent.getAttribute("tid");
						//console.log("找到boxid,tid："+tid);
						if(tid) {
							return parent
							break;
						} else {
							parent = parent.parentNode;
						}
					}
				}
				return event.target;
			}
			onDragSelect=(event, isShowDom)=> {
				let that = this;
				this.state.dragItem = null;
				let btnNum = event.button;
				if(btnNum === 2) {
				} else if(btnNum === 0) {
					this.state.isShowDom = isShowDom;
					this.state.isMouseDown = true;
					this.state.currentSelectDom = null;
					this.state.currentSelectDomId = null;
					let target = this.getSelectComponentId(event);
					if(target !== null) {

						this.state.currentSelectDomId = target.getAttribute("tid");
						
						this.state.pagenode = target.getAttribute("pagenode");
						
						
					}
					this.state.point.x = event.clientX;
					this.state.point.y = event.clientY;
					this.state.lastPoint.x = event.clientX;
					this.state.lastPoint.y = event.clientY;
					this.state.hasChanged = false;
					this.state.isStartDrag = false;
					let fromBox= this.getTargetBox(event);
					if(fromBox !== null) {
						this.state.fromBoxId = fromBox.getAttribute("boxid");
					}
					$("body").on("mousemove", this.onmousemove)
					
					//this.onEvent("mousemove", this.onmousemove)
					$("body").on("mouseup", this.onmouseup);
				}
			}
			startDrag=(event)=> {
				//console.log(this.state);
				let state = JSON.parse(JSON.stringify(this.state))


				// state.disableX = false;
				// state.disableY = false;
				state.dragItem = null;
				if(state.isStop === true) {
					return;
				}

				if(state.isMouseDown === true && state.currentSelectDomId !== null) {

					console.log("移动00000")
					state.isDraging = true;
					document.body.style.cursor="move";
					let selectDom =  this.getSelectComponentId(event);;
					if(selectDom  ) {
						let left0 = parseInt($(selectDom).offset().left);
						let top0 = parseInt($(selectDom).offset().top);
						let width = parseInt($(selectDom).width());
						let height = parseInt($(selectDom).height());
						state.sourceRect.left = left0;
						state.sourceRect.top = top0;
						state.sourceRect.width = width;
						state.sourceRect.height = height;
						//console.log("dddd")
						//console.log(event);
						state.sourceRect.offerX = event.clientX - left0;
						state.sourceRect.offerY = event.clientY - top0;
						console.log(left0 + " " + top0 + " " + width + " " + height + "  X:" + state.point.x + " Y:" + state.point.y);


					//	console.log("state.isShowDom :" + state.isShowDom)
							if(state.isShowDom != false) {
							let left = state.sourceRect.left + "px";
							let top = state.sourceRect.top + "px";
							state.style.width = state.sourceRect.width + "px";
							state.style.height = state.sourceRect.height + "px";
							state.style["transform"] = "rotate(0deg)  translate(" + left + "," + top + ")";
							state.style["WebkitTransform"] = "rotate(0deg) translate(" + left + "," + top + ")";
							let cln = selectDom.cloneNode(true);

							$("#" + state.id).empty();
							$("#" + state.id).append(cln);
						} else {
							let w = 30;
							let h = 30;
							let left = (event.clientX - (w / 2)) + "px";
							let top = (event.clientY - (h / 2)) + "px";
							state.style.width = w + "px";
							state.style.height = h + "px";
							$("#" + state.id).empty();
							state.style["transform"] = "rotate(0deg) translate(" + left + "," + top + ")";
							state.style["WebkitTransform"] = "rotate(0deg) translate(" + left + "," + top + ")";
							state.style["borderRadius"]="50%";
						}
						state.startPoint.x = event.clientX;
						state.startPoint.y = event.clientY;
						let that = this;
						this.sendEvent("drag", {
							tid: state.currentSelectDomId,
							boxid: that.state.fromBoxId,
							callback: function(item) {
								//alert("收到回调？")
								item.isFloat = true;
								state.dragItem = item;
							}
						});
					}


				}
				this.setState(state);
			}
			onmousemove=(event)=> {

				//let state = JSON.parse(JSON.stringify(this.state))
				let state = this.state;
				
				let newStyle =JSON.parse(JSON.stringify(this.state.style));
				
				window.isMoving = true;
				
				//console.log("right:::::: event.clientXY:"+event.clientX+","+event.clientY)

				//console.log("right::::::X:"+state.point.x );
				if(event.clientX === state.point.x && event.clientY === state.point.y) {
					console.log("right::::::X:return0" );
					return;
				}
				// if(!((event.clientX -state.point.x)>3||(event.clientX -state.point.x)<-3 || (event.clientY - state.point.y)>3||(event.clientY - state.point.y)<-3)) {
				// console.log("right::::::X:return" );
				// 	return;
				// }
				if(state.isStartDrag === false) {
					state.isStartDrag = true;
					this.startDrag(event);
				}
				if(state.isStop === true) {
					console.log("right::::::X:isStop=true" );
					return;
				}
				if(event.clientX === state.lastPoint.x && event.clientY === state.lastPoint.y) {
					//console.log("right::::::xiangdeng" );
					return;
				}

				let toBox = this.getTargetBox(event);
				
				let newBoxId = "";
				if(toBox) {
					  newBoxId = toBox.getAttribute("boxid");
					//console.log("要移动到box:" + newBoxId)
				} else {
				}
				
			//	console.log("right::::::state.isMouseDown :" + state.isMouseDown+" state.currentSelectDomId:"+state.currentSelectDomId);
				if(state.isMouseDown  && state.currentSelectDomId ) {
					//console.log("right::::::state.disableX :" + state.disableX);
					//console.log(state.dragItem);
					if(state.dragItem===null)
					{
						return;
					}
					
					document.body.style.cursor="move";
					
					if(state.dragItem.name === 'fs-box'||(state.dragItem.style&&state.dragItem.style.position==="absolute")) {
						state.isFsBox = true;
					}
					else
					{
						state.isFsBox = false;
					}
					
					state.dragItem.isMoving=true;
					//console.log("right:::: state.isShowDom "+state.isShowDom );
						if(state.isShowDom != false) {
							let left = (event.clientX - (state.sourceRect.offerX)) + "px";
							let top = (event.clientY - (state.sourceRect.offerY)) + "px";
							//console.log("设置x：y:" + left + " " + top + state.disableX);
							if(this.disableX == false) {
								newStyle["transform"] = "  translate(" + left + "," + top + ")";
								newStyle["WebkitTransform"] = " translate(" + left + "," + top + ")";
							} else 
							
							{
								let left0 = (state.sourceRect.left+5) + "px";
								newStyle["boxShadow"]="0 4px 12px 0 rgba(0, 0, 0, .16), 0 0 6px 0 rgba(0, 0, 0, .16)";
								newStyle["transform"] = "rotate(0deg) translate(" + left0 + "," + top + ")";
								newStyle["WebkitTransform"] = "rotate(0deg) translate(" + left0 + "," + top + ")";
							}
						} else {
							let w = 30;
							let h = 30;
							let left = (event.clientX - (w / 2)) + "px";
							let top = (event.clientY - (h / 2)) + "px";
							newStyle["transform"] = " translate(" + left + "," + top + ")";
							newStyle["WebkitTransform"] = " translate(" + left + "," + top + ")";
							newStyle["borderRadius"]="50%";
						}
					state.endPoint.x = event.clientX;
					state.endPoint.y = event.clientY;
					if(toBox !== null) {
						  newBoxId = toBox.getAttribute("boxid");
						  
						  
						if(newBoxId !== state.fromBoxId) {
							this.sendEvent("dragout", {
								x: event.clientX,
								y: event.clientY,
								item: state.dragItem
							});
							state.fromBoxId = newBoxId;
						}
						let toTarget = this.getTargetComponentId(event);
						let toTargetId = null;
						if(toTarget !== null) {
							//console.log("获取toTargetId："+toTargetId);
							toTargetId = toTarget.getAttribute("tid");
						}
						
						
						
						// 计算移动方向
						let fangxiang = "up";
						let xd = event.clientX-state.lastPoint.x;
						let yd = event.clientY-state.lastPoint.y;
						
						if(yd<=0&&(Math.abs(xd)<=Math.abs(yd)))
						{
							fangxiang = "up";
						}
						
						if(yd>=0&&(Math.abs(xd)<=Math.abs(yd)))
						{
							fangxiang = "down";
						}
						
						if(xd<=0&&(Math.abs(xd)>=Math.abs(yd)))
						{
							fangxiang = "left";
						}
						
						if(xd>=0&&(Math.abs(xd)>=Math.abs(yd)))
						{
							fangxiang = "right";
						}
						
						//console.log("fagnxiang:"+fangxiang);
						//console.log(">>>>>>>>>>name:"+state.dragItem.name+" "+(state.endPoint.x)+" y:"+state.endPoint.y+" toTargetId:"+toTargetId+" newBoxId:"+newBoxId);
						
						//如果不是在同一元素上，可以进行交换
						// if(((toTargetId === null && that.lastPoint.targetId!=="null" )||(toTargetId!==null&&toTargetId !== that.lastPoint.targetId))||that.dragItem.name==='fs-text'||that.dragItem.name==='fs-pic' ||(that.dragItem&&that.dragItem.style&&that.dragItem.style.position==="absolute")|| (newBoxId !== that.lastPoint.boxid   )) {
							
						//console.log("toTargetId:"+toTargetId+" itemId:"+state.dragItem.id);
						if(state.dragItem !== null && (toTargetId != state.dragItem.id||state.dragItem.name=='fs-text'||state.dragItem.name==='fs-pic' ||(state.dragItem.style&&state.dragItem.style.position==="absolute"))) {
							state.hasChanged = true;
							if(((!toTargetId )||(fangxiang!=state.lastPoint.fangxiang)||(toTargetId!==null&&toTargetId !== state.lastPoint.targetId))||state.dragItem.name==='fs-text'||state.dragItem.name==='fs-pic' ||(state.dragItem&&state.dragItem.style&&state.dragItem.style.position==="absolute")|| (newBoxId !== state.lastPoint.boxid   )) 
							{
								// 不能太频繁，会导致抖动，每200ms执行一次
								let currentTime = new Date();
								let time1 = currentTime.getTime();
								// &&((toTargetId!==null&&toTargetId !== state.lastPoint.targetId)||(!toTargetId&&state.lastPoint.targetId))
								//if((!this.lastDragingTime||time1-this.lastDragingTime>100))
								{
									// console.log("/draging  传递id:"+state.dragItem.name+" "+(state.endPoint.x)+" y:"+state.endPoint.y+" toTargetId:"+toTargetId+" newBoxId:"+newBoxId);
									this.sendEvent("draging", {
										x: event.clientX,
										y: event.clientY,
										item: state.dragItem,
										boxId: newBoxId,
										pagenode:state.pagenode,
										event:event,
										targetId: toTargetId,
										startPoint: state.startPoint,
										endPoint: state.endPoint,
										fangxiang:fangxiang,
										moveX: state.endPoint.x - state.startPoint.x,
										moveY: state.endPoint.y - state.startPoint.y,
									});
									
									//console.log(fangxiang+"移动坐标：X:"+event.clientX+" Y:"+event.clientY+" toTargetId:"+toTargetId+" boxId:"+newBoxId);
									//console.log("移动坐标",state.dragItem);
									
									this.lastDragingTime = time1;
									state.lastPoint.targetId = toTargetId;
									state.lastPoint.boxid = newBoxId;
									state.lastPoint.fangxiang = fangxiang;
								}
								
								
								
							}
							else
							{
								//console.log("没有变化dragging");
							}
						}
						else
						{
							//console.log("没有变化");
						}
						state.lastPoint.x = event.clientX;
						state.lastPoint.y = event.clientY;
						
						
						if(toTargetId===null)
						{
							state.lastPoint.targetId = "null";
						}
						else
						{
						
						}
						
					}
				} 
				
				state.style = newStyle;
				this.setState(state);
			}
			onmouseup=(event)=> {
				document.body.style.cursor = "default";
				
				setTimeout(()=>{
					window.isMoving= false;
					//that.state.dragItem
					
					if(this.state.dragItem)
					{
						this.state.dragItem.isMoving=false;
						this.sendEvent(this.state.dragItem.id + ".reload", "");
					}
					
				},10);
				
				
				this.disableX = false;
				this.state.disableY = false;
				let btnNum = event.button;
				if(btnNum === 2) {
					return;
				} else if(btnNum === 0) {
					this.state.isMouseDown = false;
					clearTimeout(this.startTimer);
					this.state.isDraging = false;
					document.body.style.cursor="default";
					let that = this;
					$("body").css("cursor", "default");
					let newBoxId = null;
					let toBox = this.getTargetBox(event);
					if(toBox !== null) {
						newBoxId = toBox.getAttribute("boxid");
						//console.log("newboxId:" + newBoxId)
					}
					 
					if(this.state.currentSelectDomId !== null && this.state.isStartDrag === true) {
						this.sendEvent("droped", {
							x: event.clientX,
							y: event.clientY,
							boxid: newBoxId,
							pagenode:that.state.pagenode,
							item: that.state.dragItem,
							hasChanged: this.state.hasChanged,
						});
					}
					$("body").off("mousemove")
					$("body").off("mouseup", this.onmouseup);
					 
				}

				this.setState(this.state);
			}

  render(){
  return(
  
   

 this.state.isDraging===true&&this.state.isFsBox===false && 
 <div id={this.state.id} className={` kee-fs-drager  ${this.state.isShowDom===false?'  ':''}`}   style={this.state.style } >
</div>
  );}
 }
